import { FETCH_FUNDRAISER_ASSIGNMENT_TYPES_SUCCEEDED } from './fundraiserAssignmentType.action';
import { pathOr } from 'ramda';

export const fundraiserAssignmentTypeReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_FUNDRAISER_ASSIGNMENT_TYPES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/fundraiserAssignmentTypes/fundraiserAssignmentType.reducer.js